import type { FC } from 'react';
import { ModelSelect } from './model.select';

interface ChatHeaderProps {
  title?: string;
  member: string;
  setMember: (member: string) => void;
  model: string;
  setModel: (member: string) => void;
  onOpenSettings: () => void;
}

export const ChatHeader: FC<ChatHeaderProps> = ({ model, setModel }) => {
  return (
    <header className="z-[70] w-fit m-auto bg-transparent gap-2 px-2 pt-1 flex items-center top-0 justify-center sticky">
      <div className="flex items-center gap-2">
        <ModelSelect value={model} onChange={setModel} />
      </div>
    </header>
  );
};
